var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5660E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.027 7.438C16.055 5.96 14.178 6 14.178 6l-.192.22c2.329.712 3.411 1.739 3.411 1.739a11.167 11.167 0 0 0-6.89-1.288c-.082 0-.15.014-.233.028-.48.04-1.644.219-3.11.863-.506.232-.808.397-.808.397S7.493 6.877 9.96 6.164L9.822 6s-1.877-.041-3.85 1.438c0 0-1.972 3.576-1.972 7.987 0 0 1.15 1.986 4.178 2.082 0 0 .507-.617.918-1.137-1.74-.52-2.397-1.617-2.397-1.617s.137.096.383.233c.014.014.027.028.055.041.041.028.082.042.123.069.343.192.685.342 1 .466a11.5 11.5 0 0 0 2.014.589 9.594 9.594 0 0 0 3.548.013 9.016 9.016 0 0 0 1.986-.589 7.839 7.839 0 0 0 1.575-.808s-.684 1.123-2.479 1.63c.411.52.904 1.11.904 1.11C18.836 17.41 20 15.425 20 15.425c0-4.411-1.973-7.987-1.973-7.987M9.44 14.151c-.767 0-1.398-.685-1.398-1.52 0-.837.617-1.521 1.398-1.521.78 0 1.41.684 1.397 1.52 0 .836-.617 1.52-1.397 1.52m5 0c-.768 0-1.398-.685-1.398-1.52 0-.837.617-1.521 1.397-1.521.781 0 1.398.684 1.398 1.52s-.617 1.52-1.398 1.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.645eaec17a79e19c216224ad085d9d85.svg";
export { ForwardRef as ReactComponent };